var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgFilter = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21.107,
    height: 16.904,
    viewBox: "0 0 21.107 16.904",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "filtrar",
    d: "M.66,54.39H11.4a2.746,2.746,0,0,0,5.332,0h3.716a.66.66,0,0,0,0-1.319H16.731a2.746,2.746,0,0,0-5.332,0H.66a.66.66,0,0,0,0,1.319ZM14.065,52.3a1.428,1.428,0,1,1-1.428,1.427A1.429,1.429,0,0,1,14.065,52.3ZM.66,60.1H4.376a2.746,2.746,0,0,0,5.332,0h10.74a.66.66,0,1,0,0-1.319H9.708a2.746,2.746,0,0,0-5.332,0H.66a.66.66,0,0,0,0,1.319Zm6.382-2.087a1.428,1.428,0,1,1-1.428,1.428A1.429,1.429,0,0,1,7.042,58.008Zm13.406,6.473H16.731a2.746,2.746,0,0,0-5.332,0H.66a.66.66,0,0,0,0,1.319H11.4a2.746,2.746,0,0,0,5.332,0h3.716a.66.66,0,0,0,0-1.319Zm-6.382,2.087a1.428,1.428,0,1,1,1.428-1.428A1.429,1.429,0,0,1,14.065,66.568Z",
    transform: "translate(0 -50.984)",
    fill: "#016ece"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFilter, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/filter.968a24ef.svg";
export { ForwardRef as ReactComponent };